<template>
    <!-- TODO: Texte in Translation-Tags transformieren -->
    <div class="vld-parent" ref="testContainer">
        <test-timer ref="testTimer" v-bind:time="test.available_time" v-bind:currentTime="status.currentTime"
                    v-on:countdownEnded="handleCountdownEnded()" v-on:emitTime="handleTimeEmitted($event)"></test-timer>
        <question
            v-bind:question="questions[status.currentQuestion]"
            v-bind:currentQuestion="status.currentQuestion"
            v-bind:choices="currentChoices"
            v-bind:isLast="status.isLast"
            v-bind:questionCount="questions.length"
            v-bind:answersSaved="status.answers"
            v-on:next-question="incCurrentQuestion()"
            v-on:previous-question="decCurrentQuestion(status.currentQuestion)"
            v-on:handleAnswerChange="handleAnswerChange($event)"
            v-on:testSubmit="handleSubmit()"
            v-on:setCurrentQuestion="setCurrentQuestion($event)"
            v-if="!status.hasEnded && status.started"
        >
        </question>
        <div v-show="status.hasEnded" class="alert alert-warning">
            <p>Die Zeit ist abgelaufen! Mit einem Klick auf den Button "Absenden" werden deine
                Antworten abgesendet und automatisch überprüft. Danach erhältst du sofort dein Ergebnis.</p>
        </div>
        <form class="form mt-3 mb-3" @submit.prevent.once="handleSubmit" action="/test/submit" method="post">
            <input type="hidden" name="_token" :value="csrf">
            <input type="hidden" name="answers" :value="status.answers">
            <input type="hidden" name="testAttemptId" :value="testAttempt.id">
            <input type="hidden" name="questionIds" :value="status.questionIds">
            <button
                v-show="status.hasEnded || (status.isLast && (status.questionValidation.length === questions.length))"
                type="submit"
                class="btn btn-success pull-right">
                Absenden
            </button>
            <div class="alert alert-danger"
                 v-show="status.isLast && (status.questionValidation.length < questions.length)">
                Sie haben noch nicht alle Fragen beantwortet!
            </div>
        </form>
        <button @click="startTest" class="btn btn-success" v-if="!status.started">Start Test</button>
    </div>
</template>
<script>
    export default {
        props: [
            'title',
            'questions',
            'test_id',
            'testAttempt',
            'test'
        ],
        data() {
            return {
                'csrf': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'testTimer': null,
                'currentChoices': null,
                'status':
                    {
                        'testAttemptId': null,
                        'currentTime': 0,
                        'currentQuestion': 0,
                        'isLast': false,
                        'answers': [],
                        'currentTestAttempt': null,
                        'questionValidation': [],
                        'testSubmitted': false,
                        'hasEnded': false,
                        'questionIds': [],
                        'started': false,
                        'started-at': null,
                    },
                loader: null,
                isLoading: true
            }
        },
        watch: {
            'status.currentQuestion': function () {
                this.getChoices();
            },
            isLoading: function(){
                if(this.isLoading === true){
                   this.loader = this.$loading.show({});
                } else {
                    this.loader.hide();
                }
            }
        },
        methods: {
            incCurrentQuestion: function () {
                if (this.status.currentQuestion < this.questions.length) {
                    this.status.currentQuestion++;
                    if ((this.status.currentQuestion + 1) === this.questions.length) {
                        this.status.isLast = true;
                    }
                }
            },
            decCurrentQuestion: function () {
                if (this.status.currentQuestion > 0) {
                    this.status.currentQuestion--;
                    this.status.isLast = false;
                }
            },
            getChoices: function () {
                this.isLoading = true;
                axios.get('/test/getChoices/' + this.questions[this.status.currentQuestion].id)
                    .then((response) => {
                        this.currentChoices = response.data;
                    })
                    .finally(() => this.isLoading = false);
            },
            handleAnswerChange: function (data) {
                if (!(this.status.questionValidation.includes(data.questionId))) {
                    this.status.questionValidation.push(data.questionId);
                    this.status.questionValidation.sort();
                }
                this.saveAnswers(data.answers);
            },
            handleSubmit: function () {
                this.testTimer.$refs.countdown.end();
                localStorage.removeItem('hp_test_status');
            },
            setCurrentQuestion: function (questionId) {
                this.status.currentQuestion = questionId - 1;
                this.status.isLast = (this.status.currentQuestion + 1) === this.questions.length;
            },
            checkForm: function (e) {
                if (this.status.questionValidation.length < this.questions.length) {
                    this.$store.commit('addMessage', {
                        message: 'Bitte beantworten Sie alle Fragen.',
                        type: 'alert-danger'
                    });
                } else {
                    return true;
                }
                if (this.status.testSubmitted) {
                    this.$store.commit('addMessage', {
                        message: 'Sie haben Ihre Antworten bereits übermittelt!',
                        type: 'alert-danger'
                    });
                } else {
                    return true;
                }
                e.preventDefault();
            },
            handleCountdownEnded: function () {
                this.status.hasEnded = true;
            },
            handleTimeEmitted: function (data) {
                this.status.currentTime = data.totalMilliseconds;
                localStorage.setItem('hp_test_status', JSON.stringify(this.status));
            },
            initStatus: function () {
                if (this.status.testAttemptId === null) {
                    this.status.testAttemptId = this.testAttemptId;
                }

                if (localStorage.getItem('hp_test_status')) {
                    this.status = JSON.parse(localStorage.getItem('hp_test_status'));
                }

            },
            initTest: function () {
                this.getChoices();
                this.testTimer = this.$refs.testTimer;
                this.initStatus();
                this.calculateRemainingTime();
                if (this.status.started === true) {
                    this.testTimer.$refs.countdown.start();
                }
            },
            startTest: function () {
                if (this.status.started === false) {

                    this.saveTestStartTime();
                    this.status.started = true;
                }
                this.calculateRemainingTime();
                this.testTimer.$refs.countdown.start();
            },
            saveAnswers: function (answers) {
                // todo: Antworten asynchron direkt bei Antwort in die Datenbank..
                this.status.answers = answers;
            },
            saveTestStartTime: async function () {
                axios.get('/test/saveTestStartTime/' + this.testAttempt.id).then((response) => {

                })
            },
            calculateRemainingTime() {
                let now = Date.now();
                let start = Date.parse(this.testAttempt.started_at);
                let end = start + this.test.available_time * 60000;
                let remaining = end - now;
                Vue.set(this.status, 'currentTime', remaining);
            },
            hideLoader() {
                this.loader.hide();
            }
        },
        mounted: function () {
            this.loader = this.$loading.show({});
            window.addEventListener('load', () => {
                this.initTest();
                this.isLoading = false;
            });
        }
    }
</script>
